import { render, staticRenderFns } from "./PrivacyGame.vue?vue&type=template&id=09492397&scoped=true&"
import script from "./PrivacyGame.vue?vue&type=script&lang=js&"
export * from "./PrivacyGame.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyGame.vue?vue&type=style&index=0&id=09492397&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09492397",
  null
  
)

export default component.exports